import { Component } from '@angular/core';
import { TabHeader, TabsComponent } from '@shared/components/tabs/tabs.component';
import { DiscountsComponent } from './discounts/discounts.component';
import { PlatformComponent } from './platforms/platform.component';
import { ProductComponent } from './products/product.component';

interface ConfigTab {
	id: string;
	labelKey: string;
	icon: string;
}

@Component({
	selector: 'app-configuration',
	imports: [TabsComponent, PlatformComponent, ProductComponent, DiscountsComponent],
	templateUrl: './configuration.component.html',
	styleUrl: './configuration.component.scss',
})
export class ConfigurationComponent {
	selectedTab = 0;

	private allTabs: ConfigTab[] = [
		{ id: 'products', labelKey: 'configuration.tabs.products', icon: 'Package' },
		{ id: 'platforms', labelKey: 'configuration.tabs.platforms', icon: 'Globe' },
		{ id: 'discounts', labelKey: 'configuration.tabs.discounts', icon: 'Percent' },
	];

	get visibleTabs(): ConfigTab[] {
		return this.allTabs;
	}

	get tabHeaders(): TabHeader[] {
		return this.visibleTabs.map(({ labelKey, icon }) => ({ labelKey, icon }));
	}

	get activeTabId(): string {
		return this.visibleTabs[this.selectedTab]?.id ?? 'products';
	}
}
